package one.healthium.insights.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class TextStyleDto(
    @SerialName("color") val color: String? = null,
    @SerialName("font_weight") val fontWeight: String? = null,
    @SerialName("font_style") val fontStyle: String? = null,
    @SerialName("font_size") val fontSize: Int? = null,
    @SerialName("alignment") val alignment: String? = null,
)